import { ComponentFrameworkContextMenu } from '@utils/component-framework';
import { useGGBAppletApi } from '../context.applet.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useShareGeogebraEntryMutation } from '../state/mutation.share-entry.js';

const printCss = `
  @media print {
    @page {
      margin: 0;
      size: A4;
    }

    body {
      -webkit-print-color-adjust: exact !important;
    }

    * {
      transition: none !important;
    }

    div[data-print-wrapper] {
      display: block;
    }
  }
`;
function GeogebraContextMenu(props) {
  const appletApi = useGGBAppletApi();
  const shareEntryWithTeacherMutation = useShareGeogebraEntryMutation();
  const onShareWithTeacher = () => {
    props.onShareWithTeacher?.();
    shareEntryWithTeacherMutation(props.component.entryKey);
  };
  const onBeforePrint = async () => {
    return new Promise(resolve => {
      if (!appletApi) {
        resolve(undefined);
        return;
      }
      appletApi.exportSVG(svg => {
        const printTarget = props.printRef.current;
        if (!printTarget) {
          return;
        }

        // gymnastics to avoid running into issues with window.btoa only
        // handling ASCII / Latin1 characters, which we are not guaranteed will
        // be the case for SVGs returned by the GeoGebra applet
        //
        // therefore, we instead rely on the built-in Blob and FileReader APIs
        // to convert the string to a DataURL for us, rather than doing a custom
        // implementation, this also ensures that a complaint and correct output
        // in all edge cases
        const reader = new FileReader();
        reader.onload = function () {
          printTarget.src = String(reader.result);
          resolve(undefined);
        };
        reader.readAsDataURL(new Blob([svg], {
          type: "image/svg+xml"
        }));
      });
    });
  };
  return /*#__PURE__*/jsxs(ComponentFrameworkContextMenu, {
    className: props.className,
    axis: "horisontal",
    nodeId: props.nodeId,
    layout: props.layout,
    enabled: props.enabled,
    children: [/*#__PURE__*/jsx(ComponentFrameworkContextMenu.Button, {
      type: "export-legacy",
      componentTitle: props.component.envelope.Title,
      input: {
        ref: props.componentRef
      },
      targets: {
        pdf: true
      },
      printCss: printCss,
      printOrientation: "landscape",
      onBeforeExport: onBeforePrint
    }), /*#__PURE__*/jsx(ComponentFrameworkContextMenu.Button, {
      type: "drive-legacy",
      format: "pdf",
      componentTitle: props.component.envelope.Title,
      entryKey: props.component.entryKey,
      input: {
        ref: props.componentRef
      },
      printCss: printCss,
      onBeforeExport: onBeforePrint,
      printOrientation: "landscape"
    }), /*#__PURE__*/jsx(ComponentFrameworkContextMenu.Button, {
      type: "legacy-print",
      printCss: printCss,
      targetRef: props.componentRef,
      onBeforePrint: onBeforePrint
    }), /*#__PURE__*/jsx(ComponentFrameworkContextMenu.Button, {
      type: "share",
      componentId: props.component.envelope.ID,
      entryKey: props.component.entryKey,
      onShareWithTeacher: onShareWithTeacher
    }), props.children]
  });
}

export { GeogebraContextMenu };
//# sourceMappingURL=integration.context-menu.js.map
